import { render, staticRenderFns } from "./TranshipmentPreviewData.vue?vue&type=template&id=0a06da60"
import script from "./TranshipmentPreviewData.vue?vue&type=script&lang=js"
export * from "./TranshipmentPreviewData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports